import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { t } from "../translations";
import "./styles/404.css";

const Custom404 = () => {
  const lang = useSelector((state) => state.lang);

  return (
    <div id="notfound">
      <div className="notfound">
        <div className="notfound-404">
          <h1>Oops!</h1>
        </div>
        <h2>{t("error_404.lost_message", lang)}</h2>
        <p>{t("error_404.page_not_found", lang)}</p>
        <Link to="/">
          <button>{t("error_404.back_to_homepage", lang)}</button>
        </Link>
      </div>
    </div>
  );
};

export default Custom404;
